import { graphql } from 'gatsby';
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import * as React from 'react';
export default {
  graphql,
  Callout,
  CalloutTitle,
  CalloutText,
  React
};